// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductListProductInformationStyles } from "@rugby/Overrides/Widgets/ProductList/ProductListProductInformation";
import { screen } from "@rugby/XDL/Helpers";
import { ellipsis } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

const productPartNumbersDefaultStyle = {
    text: {
        css: css`
            font-weight: normal;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 21px;
        `,
    },
};

const productAttributeGridItemDefaultStyle = (withMarginRight: boolean) => {
    return {
        css: css`
            &&& {
                ${withMarginRight && `margin-right: 8px;`}
            }
        `,
    };
};

const customProductInformationStyles: ProductListProductInformationStyles = {
    container: {
        gap: 5,
        css: css`
            width: 100%;
            flex-grow: 0;
        `,
    },
    descriptionStyles: {
        productDetailLink: {
            color: "secondary.main",
            css: css`
                min-height: 37px;
                margin-bottom: 7px;
                display: inline-flex;
                ${screen("lte", "md")`
                    margin-bottom: 12px;
                `}
            `,
            typographyProps: {
                color: "secondary.main",
                size: 16,
                css: css`
                    width: 100%;
                    line-height: 22px;
                    letter-spacing: 0;
                    ${ellipsis(2, 22)}
                    &&& {
                        display: -webkit-box;
                    }
                `,
            },
        },
    },
    partNumbersStyles: {
        erpNumberLabelText: productPartNumbersDefaultStyle.text,
        customerNameLabelText: productPartNumbersDefaultStyle.text,
        manufacturerItemLabelText: productPartNumbersDefaultStyle.text,
        erpNumberValueText: productPartNumbersDefaultStyle.text,
        customerNameValueText: productPartNumbersDefaultStyle.text,
        manufacturerItemValueText: productPartNumbersDefaultStyle.text,
    },
    brandGridItem: {
        width: 12,
    },
    descriptionGridItem: {
        width: 12,
    },
    partNumbersGridItem: {
        width: 12,
    },
    availabilityGridItem: {
        width: 12,
    },
    attributesGridItem: {
        width: 12,
    },
    attributes: {
        attributeWrapper: {
            css: css`
                width: 100%;
                display: flex;
            `,
        },
        attributeTypeGridItem: {
            css: css`
                ${productAttributeGridItemDefaultStyle(true).css}
                flex-shrink: 0;
            `,
        },
        attributeValueGridItem: productAttributeGridItemDefaultStyle(false),
        attributeTypeText: {
            css: productPartNumbersDefaultStyle.text.css,
        },
        attributeValueText: productPartNumbersDefaultStyle.text,
    },
};

export default customProductInformationStyles;
